import { component } from 'picoapp';
import Cookie from 'js-cookie';
import Modal from 'utils/modal';

export default component(async (node) => {
  const { shops } = window.theme;
  const internationalShop = shops.find(
    (shop) => shop.countryCode === 'INTERNATIONAL'
  );
  const currentShop = shops.find((shop) => shop.shopifyDomain === Shopify.shop);
  const modalElement: HTMLElement = node.querySelector('[data-modal]');
  const modal = Modal(modalElement);
  const countryList = node.querySelector('[data-countries]');
  const goToShopButton: HTMLElement = node.querySelector(
    '[data-go-to-country]'
  );
  const closeButton: HTMLButtonElement = node.querySelector('[data-close]');
  const statusTextElement: HTMLParagraphElement =
    node.querySelector('[data-text]');

  const initPopup = (location) => {
    shops.forEach((shop) => {
      const element = `
        <li class="mt-2 ml-2">
          <a
            class="geoselector__list--icon"
            href="https://${
              shop.domain !== '' ? shop.domain : shop.shopifyDomain
            }"
          >
          <div class="w-full">
            <div class="aspect-ratio aspect-ratio--4/3">
              <img src="${shop.flagIcon}" alt="${shop.title}">
            </div>
          </div>
          </a>
        </li>
      `;
      countryList.insertAdjacentHTML('afterbegin', element);
    });

    let statusText = statusTextElement.textContent;
    statusText = statusText.replaceAll(
      '{{ country }}',
      currentShop ? currentShop.countryCode : 'development'
    );
    statusText = statusText.replaceAll('{{ location }}', location.name);
    statusTextElement.textContent = statusText;

    const findShop = shops.find(
      (shop) =>
        shop.countryCode.toLowerCase() === location.country.toLowerCase()
    );
    const country = findShop?.countryCode ?? internationalShop.title;
    const domain = findShop?.domain ?? internationalShop.domain;
    let goToShopText = goToShopButton.textContent;

    goToShopText = goToShopText.replace('{{ country }}', country);
    goToShopButton.setAttribute('href', `https://${domain}`);
    goToShopButton.textContent = goToShopText;
  };

  const isPathExcluded = () => {
    const excludedPaths = JSON.parse(node.dataset.excludedPaths || '[]');
    const currentPath = decodeURIComponent(window.location.pathname);

    // Handle front page case
    if (currentPath === '/' || currentPath === '') {
      return excludedPaths.some(
        (path) => path.trim() === 'index' || path.trim() === '/'
      );
    }

    return excludedPaths.some(
      (path) =>
        path.trim() &&
        decodeURIComponent(currentPath).startsWith(
          decodeURIComponent(path.trim())
        )
    );
  };

  const getLocation = async () => {
    // Don't proceed if path is excluded
    if (isPathExcluded()) {
      return;
    }

    const location = await fetch(
      'https://get.geojs.io/v1/ip/country.json'
    ).then((response) => response.json());
    // Only open if not on current locale
    if (Shopify.country.toLowerCase() !== location.country.toLowerCase()) {
      initPopup(location);
      modal.open();
    }

    Cookie.set('geopopup', true, { expires: 365 });
  };

  const hasCookie = Cookie.get('geopopup') !== undefined;

  if (!hasCookie) {
    getLocation();
  }

  closeButton.addEventListener('click', () => {
    modal.close();
  });
});
